module.exports = __webpack_public_path__ + "img/arms-bg7.e1c7e1ba.png";